export default __webpack_public_path__ + "fonts/kingvision_bg_outer.827e61cb4dbd91915dcd1608c8a625fb.png";